import type { Asset } from '@schibsted-svp/svp-api-types';
import type { StreamProvider } from '@vgtv/api-client';
import { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';

import { PaywallButtons } from '../../components/PaywallButtons/PaywallButtons';
import { SportUpcomingEvents } from '../../components/SportUpcomingEvents/SportUpcomingEvents';
import { SportUpcomingEventsProvider } from '../../hooks/SportUpcomingEventsProvider/SportUpcomingEventsProvider';

export const PaywallButtonsWrapper = ({
  accessLevel,
  asset,
  isMobile,
}: {
  asset: Asset;
  accessLevel?: ProviderAccessMap[StreamProvider];
  isMobile: boolean;
}) => {
  return (
    <div className="vgp-paywall-buttons-wrapper">
      <PaywallButtons
        color="primary"
        asset={asset}
        accessLevel={accessLevel}
        size="standard"
      />
      <SportUpcomingEventsProvider>
        <SportUpcomingEvents />
      </SportUpcomingEventsProvider>
    </div>
  );
};
